/** @jsx jsx */

import { Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

const PendingVersionLifecycleMessage = () => (
  <Text color="inherit">
    Your integration version is being updated. While the updates are running, we
    prevent additional changes to this integration. You will be able to edit it
    when the versioning operation is completed successfully.
  </Text>
);

export default PendingVersionLifecycleMessage;
